import async from "async";
import {fetchDtData, fetchFormObject, generateFetchFieldListAction, SAVE_OBJECT_SUCCESS} from "../../../apps/KpModule/actions/api"
import {changeFieldProperty, setObjectMode} from "../../../apps/KpModule/actions"
import {basicContext} from "../../utils/contextUtils";
const _ = require("lodash")
const moment = require("moment")
const { v4: uuid } = require('uuid')
const {encrypt, decrypt} = require("../../utils/crypto")
const Errors = require("../../utils/Errors").default
const {setFormButtons, setFieldEdition, setFieldVisibility, setFieldRemovable, setFieldNewable, setFieldStartDate, setFieldEndDate} = require("../../../apps/KpModule/actions")
const {getObjectMode, getUser, getGroupModel} = require("../../../apps/KpModule/selectors")
const {validateEmail} = require("../../../apps/KpModule/components/Form/formValidations")

const hasValue = value  =>
    value !== null &&
    value !== undefined &&
    (
        typeof value === 'boolean' || // accept false/true as valid values
        typeof value === 'number' || // accept any number including 0
        (typeof value === 'string' && value.trim() !== '') ||
        (Array.isArray(value) && value.length > 0) ||
        (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length > 0)
    )

export const fieldsByModel = modelId => {

    const getUsersFieldPath = formFields => formFields.map(field => {
        switch (field.type) {
            case 'tags':
            case 'dropdownObject':
                return `${field.path}.id`
            default:
                return field.path
        }
    })
    const defaultEntityFields = [
        {path: 'name', unique: true},
        {path: 'description'}
    ]
    const defaultModuleListFields = [
        {path: 'name'},
        {path: 'description'}
    ]

    const defaultModuleFormFields = [
        {path: 'name', required: true},
        {path: 'description', type: 'textarea'},
    ]

    const usersNumberGetter = formFields => ({
        path: 'numberOfUsers',
        fieldPath: [...getUsersFieldPath(formFields), 'users.id'],
        f: function() {
            return this.users ? this.users.length : 0
        }
    })

    const getUsersGetter = (formFields) => ({
        path: 'users',
        fieldPath: getUsersFieldPath(formFields),
        $f: function (object, context, callback) {

            const getRegexPattern = searchText => {
                let regexPattern;
                if (searchText.startsWith('*') && searchText.endsWith('*')) {
                    // Contains (e.g., *10*)
                    regexPattern = `.*${searchText.slice(1, -1)}.*`;
                } else if (searchText.startsWith('*')) {
                    // Ends with (e.g., *10)
                    regexPattern = `.*${searchText.slice(1)}$`;
                } else if (searchText.endsWith('*')) {
                    // Starts with (e.g., 10*)
                    regexPattern = `^${searchText.slice(0, -1)}.*`;
                } else {
                    // Exact match (e.g., 10)
                    regexPattern = `^${searchText}$`;
                }

                return regexPattern
            }

            const userQuery = formFields.filter(field => field.useInQuery).reduce((query, field) => {
                if(!hasValue(object[field.path])) return query
                switch (field.type) {
                    case 'tags':
                        query[field.target] = { $in: object[field.path].map(value => {
                            return field.staticEntity
                                ? value.id
                                : new global.ObjectID(value.id)
                            }) }
                        break
                    case 'dropdownObject':
                        query[field.target] = field.queryBuilder
                            ? field.queryBuilder(object[field.path])
                            : { $eq: field.staticEntity ? object[field.path].id : new global.ObjectID(object[field.path].id) }
                        break
                    case 'datePicker': {
                        const date = field.targetType === 'date'
                            ? moment(object[field.path], "YYYY-MM-DD").toDate()
                            : object[field.path]
                        const operator = field.operator || (field.isStartDate ? '$gte' : '$lte')
                        query[field.target] = { ...(query[field.target] || {}), [operator]: date }
                        break
                    }
                    case 'creatableTags':
                        const searchTexts = object[field.path].split(';')
                        query[field.target] = {
                            $or: searchTexts.map(searchText => {
                                const finalRegexPattern = searchText.includes('*')
                                    ? getRegexPattern(searchText)
                                    : `^${searchText}$`
                                return {$regex: new RegExp(finalRegexPattern, 'i')}
                            })
                        }
                        break
                    case 'number':
                        const operator = field.operator || '$eq'
                        query[field.target] = { ...(query[field.target] || {}), [operator]: parseFloat(object[field.path]) }
                        break
                    default:
                        const searchText = object[field.path]
                        const finalRegexPattern = searchText.includes('*')
                            ? getRegexPattern(searchText)
                            : `^${searchText}$`

                        query[field.target] = {$regex: new RegExp(finalRegexPattern, 'i')}

                }
                return query

            }, {active: true, status: {$ne: 'waiting'}})
            global.app[modelId].CUser.find({
                ...basicContext(context),
                query: userQuery,
                fieldPath: formFields.filter(field => !field.useInQuery).map(field => field.target)
            }, (error, users) => {
                if(error) return callback(error)
                return callback(error, users.filter(user => {
                    const filters = formFields.filter(field => !field.useInQuery)
                    if(!filters.length) return true

                    const evalField = (field, value) => {
                        if(!hasValue(object[field.path])) return true
                        switch (field.type) {
                            case 'tags':
                                if(_.isArray(value)) {
                                    return value.some(targetValue => object[field.path].map(v => v.id).includes(targetValue.id))
                                }
                                return value?.id && object[field.path].map(v => v.id).includes(value.id)
                            case 'dropdownObject':
                                if(_.isArray(value)) {
                                    return object[field.path]?.id && value.some(targetValue => targetValue.id === object[field.path].id)
                                }
                                return value?.id === object[field.path]?.id
                            case 'datePicker': {
                                const formValue = moment(object[field.path], "YYYY-MM-DD").format('YYYY-MM-DD')
                                const operator = field.operator || '$eq'
                                const date = moment(value, "YYYY-MM-DD").format('YYYY-MM-DD')
                                switch (operator) {
                                    case '$gt':  return date > formValue
                                    case '$gte': return date >= formValue
                                    case '$lt':  return date < formValue
                                    case '$lte': return date <= formValue
                                    case '$ne':  return date !== formValue
                                    default:     return date === formValue
                                }
                            }
                            case 'creatableTags': {
                                const searchTexts = object[field.path].split(';')
                                return searchTexts.some(searchText => {
                                    const finalRegexPattern = searchText.includes('*')
                                        ? getRegexPattern(searchText)
                                        : `^${searchText}$`
                                    const regex = new RegExp(finalRegexPattern, 'i')
                                    return _.isArray(value)
                                        ? value.some(v => regex.test(v))
                                        : regex.test(value)
                                })
                            }
                            case 'number': {
                                const numValue = parseFloat(object[field.path])
                                const operator = field.operator || '$eq'
                                switch (operator) {
                                    case '$gt':  return value > numValue
                                    case '$gte': return value >= numValue
                                    case '$lt':  return value < numValue
                                    case '$lte': return value <= numValue
                                    case '$ne':  return value !== numValue
                                    default:     return value === numValue
                                }
                            }
                            default: {
                                const searchText = object[field.path]
                                const finalRegexPattern = searchText.includes('*')
                                    ? getRegexPattern(searchText)
                                    : `^${searchText}$`
                                const regex = new RegExp(finalRegexPattern, 'i')
                                return _.isArray(value)
                                    ? value.some(v => regex.test(v))
                                    : regex.test(value)
                            }
                        }
                    }

                    // Group fields targeting a nested path (e.g. 'rightHolders.birthDate') by their
                    // parent, so conditions on the same array are checked against the same element
                    const nestedGroups = {}
                    const standaloneFilters = []

                    filters.forEach(field => {
                        const parts = field.target.split('.')
                        if(parts.length > 1) {
                            const parentPath = parts[0]
                            if(!nestedGroups[parentPath]) nestedGroups[parentPath] = []
                            nestedGroups[parentPath].push(field)
                        } else {
                            standaloneFilters.push(field)
                        }
                    })

                    const standalonePass = standaloneFilters.every(field => evalField(field, user[field.target]))
                    if(!standalonePass) return false

                    return Object.entries(nestedGroups).every(([parentPath, groupFields]) => {
                        if(!groupFields.some(field => hasValue(object[field.path]))) return true
                        const nested = user[parentPath]
                        const checkGroup = item => groupFields.every(field => {
                            const childPath = field.target.split('.').slice(1).join('.')
                            return evalField(field, _.get(item, childPath))
                        })
                        if(Array.isArray(nested)) {
                            const nestedFilter = groupFields.find(f => f.nestedFilter)?.nestedFilter
                            //if two fields or more have the same target, the first nestedFilter would be applied to both of them
                            const filteredNested = nestedFilter ? nested.filter(nestedFilter) : nested
                            return filteredNested.some(checkGroup)
                        }
                        return nested ? checkGroup(nested) : false
                    })
                }))
            })
        }
    })

    let customEntityFields = []
    let customModuleListFields = []
    let customModuleFormFields = []

    switch (modelId) {
        case 'R':
            customEntityFields = [
                {path: "civilities", type: "Civility", link: "MTM", nullable: true},
                {path: "MaritalStatuses", type: "MaritalStatus", link: "MTM", nullable: true},

                {path: "minDependentChildrenAge"},
                {path: "maxDependentChildrenAge"},

                {path: "minNumberOfDependentChildren", type: "integer", nullable: true},
                {path: "maxNumberOfDependentChildren", type: "integer", nullable: true},

                {path: "minBeneficiaryAge"},
                {path: "maxBeneficiaryAge"},

                {path: "correspondenceLanguages", type: "Language", link: "MTM", nullable: true},

                {path: "beneficiaryStatuses", type: "UserStatus", link: "MTM", nullable: true},

                {path: "minSplit", type: "integer", nullable: true},
                {path: "maxSplit", type: "integer", nullable: true},

                {path: "minEntryDate"},
                {path: "maxEntryDate"},

                {path: "minReleaseDate"},
                {path: "maxReleaseDate"},

                {path: "profiles", type: "Profile", link: "MTM", nullable: true},

                {path: "minAllocation", type: "decimal", nullable: true},
                {path: "maxAllocation", type: "decimal", nullable: true},

                {path: "releaseDateStatus", type: "ReleaseDateStatus", nullable: true},
            ]

            customModuleListFields = [
                {path: 'numberOfUsers'}
            ]

            customModuleFormFields = [
                {path: "profiles", type: "tags", filters: ["thisModel"], target: 'authorizations', translateName: true, useInQuery: true},

                {path: "civilities", type: "tags", target: 'civility', useInQuery: true, staticEntity: true, widthClassName: "col-xs-12 col-sm-6"},

                {path: "MaritalStatuses", type: "tags", target: 'maritalStatus', useInQuery: false, staticEntity: true, widthClassName: "col-xs-12 col-sm-6"},

                {path: "correspondenceLanguages", type: "tags", target: 'language', useInQuery: true, staticEntity: true, widthClassName: "col-xs-12 col-sm-6"},

                {path: "beneficiaryStatuses", type: "tags", target: 'status', useInQuery: true, staticEntity: true, widthClassName: "col-xs-12 col-sm-6"},

                {
                    path: "minEntryDate", type: "datePicker", target: 'entryDate', targetType: 'date', useInQuery: true, operator: "$gte", widthClassName: "col-xs-12 col-sm-6",
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const maxField = module.viewMap.form.fields.find(f => f.path === 'maxEntryDate')
                            store.dispatch(setFieldStartDate(maxField.id, newValue))
                        }
                    }
                },
                {
                    path: "maxEntryDate", type: "datePicker", target: 'entryDate', targetType: 'date', useInQuery: true, operator: "$lte", widthClassName: "col-xs-12 col-sm-6",
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const minField = module.viewMap.form.fields.find(f => f.path === 'minEntryDate')
                            store.dispatch(setFieldEndDate(minField.id, newValue))
                        }
                    }
                },

                {
                    path: "releaseDateStatus",
                    type: "dropdownObject",
                    target: 'releaseDate',
                    useInQuery: true,
                    staticEntity: true,
                    queryBuilder: value => value.id === 'filled' ? {$ne: null} : {$eq: null},
                    subscriptions: {
                        onChange: (newValue, oldValue, {module, store}) => {
                            const minField = module.viewMap.form.fields.find(f => f.path === 'minReleaseDate')
                            const maxField = module.viewMap.form.fields.find(f => f.path === 'maxReleaseDate')
                            const isFilled = newValue?.id === 'filled'
                            store.dispatch(setFieldVisibility(minField.id, isFilled))
                            store.dispatch(setFieldVisibility(maxField.id, isFilled))
                            if (!isFilled) {
                                minField.setValue(null)
                                maxField.setValue(null)
                            }
                        }
                    }
                },
                {
                    path: "minReleaseDate", type: "datePicker", target: 'releaseDate', targetType: 'date', useInQuery: true, operator: "$gte", widthClassName: "col-xs-12 col-sm-6",
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const maxField = module.viewMap.form.fields.find(f => f.path === 'maxReleaseDate')
                            store.dispatch(setFieldStartDate(maxField.id, newValue))
                        }
                    }
                },
                {
                    path: "maxReleaseDate", type: "datePicker", target: 'releaseDate', targetType: 'date', useInQuery: true, operator: "$lte", widthClassName: "col-xs-12 col-sm-6",
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const minField = module.viewMap.form.fields.find(f => f.path === 'minReleaseDate')
                            store.dispatch(setFieldEndDate(minField.id, newValue))
                        }
                    }
                },

                {
                    path: "minBeneficiaryAge", type: "datePicker", target: 'birthDate', targetType: 'date', useInQuery: true, operator: "$gte", widthClassName: "col-xs-12 col-sm-6", startDate: moment().format('YYYY-MM-DD'),
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const maxField = module.viewMap.form.fields.find(f => f.path === 'maxBeneficiaryAge')
                            store.dispatch(setFieldStartDate(maxField.id, newValue))
                        }
                    }
                },
                {
                    path: "maxBeneficiaryAge", type: "datePicker", target: 'birthDate', targetType: 'date', useInQuery: true, operator: "$lte", widthClassName: "col-xs-12 col-sm-6", startDate: moment().format('YYYY-MM-DD'),
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const minField = module.viewMap.form.fields.find(f => f.path === 'minBeneficiaryAge')
                            store.dispatch(setFieldEndDate(minField.id, newValue))
                        }
                    }
                },

                {
                    path: "minDependentChildrenAge", type: "datePicker", target: 'rightHolders.birthDate', useInQuery: false, operator: "$gte", nestedFilter: rh => rh.kinship?.id === 'child' && !!rh.dependent, widthClassName: "col-xs-12 col-sm-6",
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const maxField = module.viewMap.form.fields.find(f => f.path === 'maxDependentChildrenAge')
                            store.dispatch(setFieldStartDate(maxField.id, newValue))
                        }
                    }
                },
                {
                    path: "maxDependentChildrenAge", type: "datePicker", target: 'rightHolders.birthDate', useInQuery: false, operator: "$lte", nestedFilter: rh => rh.kinship?.id === 'child' && !!rh.dependent, widthClassName: "col-xs-12 col-sm-6",
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const minField = module.viewMap.form.fields.find(f => f.path === 'minDependentChildrenAge')
                            store.dispatch(setFieldEndDate(minField.id, newValue))
                        }
                    }
                },

                {
                    path: "minNumberOfDependentChildren", type: "number", target: 'numberOfChildren', useInQuery: false, operator: "$gte", widthClassName: "col-xs-12 col-sm-6",
                    minValue: 0,
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const maxField = module.viewMap.form.fields.find(f => f.path === 'maxNumberOfDependentChildren')
                            store.dispatch(changeFieldProperty(maxField.id, 'minValue', newValue || 0))
                        }
                    }
                },
                {
                    path: "maxNumberOfDependentChildren", type: "number", target: 'numberOfChildren', useInQuery: false, operator: "$lte", widthClassName: "col-xs-12 col-sm-6",
                    minValue: 0,
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const minField = module.viewMap.form.fields.find(f => f.path === 'minNumberOfDependentChildren')
                            store.dispatch(changeFieldProperty(minField.id, 'maxValue', newValue))
                        }
                    }
                },

                {
                    path: "minSplit", type: "number", target: 'split', useInQuery: true, operator: "$gte", widthClassName: "col-xs-12 col-sm-6",
                    minValue: 0,
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const maxField = module.viewMap.form.fields.find(f => f.path === 'maxSplit')
                            store.dispatch(changeFieldProperty(maxField.id, 'minValue', newValue || 0))
                        }
                    }
                },
                {
                    path: "maxSplit", type: "number", target: 'split', useInQuery: true, operator: "$lte", widthClassName: "col-xs-12 col-sm-6",
                    minValue: 0,
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const minField = module.viewMap.form.fields.find(f => f.path === 'minSplit')
                            store.dispatch(changeFieldProperty(minField.id, 'maxValue', newValue))
                        }
                    }
                },

                {
                    path: "minAllocation", type: "number", target: 'remainingAmount', useInQuery: false, operator: "$gte", widthClassName: "col-xs-12 col-sm-6",
                    minValue: 0,
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const maxField = module.viewMap.form.fields.find(f => f.path === 'maxAllocation')
                            store.dispatch(changeFieldProperty(maxField.id, 'minValue', newValue || 0))
                        }
                    }
                },
                {
                    path: "maxAllocation", type: "number", target: 'remainingAmount', useInQuery: false, operator: "$lte", widthClassName: "col-xs-12 col-sm-6",
                    minValue: 0,
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const minField = module.viewMap.form.fields.find(f => f.path === 'minAllocation')
                            store.dispatch(changeFieldProperty(minField.id, 'maxValue', newValue))
                        }
                    }
                },
            ]
            return {
                entityFields : [
                    ...defaultEntityFields,
                    ...customEntityFields,
                    getUsersGetter(customModuleFormFields),
                    usersNumberGetter(customModuleFormFields)
                ],
                moduleListFields: [
                    ...defaultModuleListFields,
                    ...customModuleListFields
                ],
                moduleFormFields: [
                    ...defaultModuleFormFields,
                    ...customModuleFormFields
                ]
            }
        case 'C':
            customEntityFields = [
                //Organization fields
                {path: "organizationType", type: "NewOrganizationType", link: "MTM", nullable: true},
                {path: "organizationStatus", type: "OrganizationStatus", link: "MTM", nullable: true},
                {path: "organizationStatus", type: "OrganizationStatus", link: "MTM", nullable: true},
                {path: "organizationActivity", type: "NewOrganizationActivity", link: "MTM", nullable: true},
                {path: "organizationAnimalType", type: "AnimalType", link: "MTM", nullable: true},
                {path: "organizationZipCode"},

                {path: "organizationContributionsStatus", type: "ContributionsStatus", nullable: true},

                {path: "establishmentZipCode"},

                //Contact fields
                {path: "contactAssociationReferent", type: "ReferentStatus", nullable: true},
                {path: "contactLiberalityReferent", type: "ReferentStatus", nullable: true},

                {path: "contactFunction", type: "Function", link: "MTM", nullable: true},
                {path: "contactProfile", type: "Profile", link: "MTM", nullable: true},

                //Shelter fields
                {path: "shelterZipCode"},



                //{path: "zipCode"},
                //{path: "zones", type: "Zone", link: "MTM", nullable: true}
            ]

            customModuleListFields = [
                //{path: 'numberOfUsers'}
            ]

            customModuleFormFields = [
                {
                    path: "organizationType", tKey: 'Type', placeholder: "Sélectionner les types", section: "Organisation", type: 'tags', target: 'organizationType', useInQuery: false, fieldPath: ['id', 'name'],
                    subscriptions: {
                        onChange: (newValue, oldValue, {module, store}) => {
                            const organizationStatusField = module.viewMap.form.fields.find(field => field.path === 'organizationStatus')
                            const contributionsStatusField = module.viewMap.form.fields.find(field => field.path === 'organizationContributionsStatus')
                            if(newValue?.length === 1 && newValue[0]?.id === 'association') {
                                store.dispatch(setFieldVisibility(contributionsStatusField.id, true))
                                store.dispatch(setFieldVisibility(organizationStatusField.id, true))
                            } else {
                                contributionsStatusField.setValue(null)
                                organizationStatusField.setValue(null)
                                store.dispatch(setFieldVisibility(contributionsStatusField.id, false))
                                store.dispatch(setFieldVisibility(organizationStatusField.id, false))
                            }
                        }
                    }
                },
                {path: "organizationStatus", tKey: 'Statut association', placeholder: "Sélectionner les status", section: "Organisation", type: 'tags', target: 'organizationStatus', useInQuery: false, fieldPath: ['id', 'name']},
                {path: "organizationContributionsStatus", tKey: "Statut des cotisations", section: "Organisation", display: "dynamicName", type: "dropdownObject", target: 'contributionsStatus', useInQuery: false, translate: true},
                {path: "organizationActivity", tKey: 'Activité', placeholder: "Sélectionner les activités", section: "Organisation", type: 'tags', target: 'organizationActivities', useInQuery: false, fieldPath: ['id', 'name']},
                {path: "organizationAnimalType", tKey: 'Espèce animale', placeholder: "Sélectionner les espèces animales", section: "Organisation", type: 'tags', target: 'organizationAnimalTypes', useInQuery: false, fieldPath: ['id', 'name']},
                {
                    path: "organizationZipCode",
                    placeholder: "Renseigner préfixe(s) code(s) postal(aux)",
                    tKey: 'Code postal',
                    section: "Organisation",
                    type: "creatableTags",
                    target: "organizationZipCode",
                    useInQuery: false,
                    style: {fontFamily: "'Courier New', Courier, monospace", letterSpacing: "0.05em",fontSize: "15px"},
                    getPreview: (values, t) => {
                        if(!values) return <></>
                        return (
                            <ul>
                                {
                                    values?.map(valueObject => {
                                        let preview = ""

                                        if (valueObject.value === "**") {
                                            preview = "Correspond à toutes les valeurs"
                                        }
                                        else if (valueObject.value .startsWith("*") && valueObject.value .endsWith("*")) {
                                            preview = `Correspond à tout ce qui contient : ${valueObject.value .slice(1, -1)}`
                                        } else if (valueObject.value .startsWith("*")) {
                                            preview = `Correspond à tout ce qui se termine avec : ${valueObject.value .slice(1)}`
                                        } else if (valueObject.value .endsWith("*")) {
                                            preview = `Correspond à tout ce qui commence par : ${valueObject.value .slice(0, -1)}`
                                        } else if (!valueObject.value .includes("*") && valueObject.value .trim() !== "") {
                                            preview = `Correspond à tout ce qui est égal à : ${valueObject.value }`
                                        }

                                        return <li>{t(preview)}</li>
                                    })
                                }
                            </ul>
                        )
                    }
                },

                //Establishment
                {
                    path: "establishmentZipCode",
                    tKey: 'Code postal',
                    placeholder: "Renseigner préfixe(s) code(s) postal(aux)",
                    section: "Etablissement",
                    type: "creatableTags",
                    target: "establishmentsZipCodes",
                    useInQuery: false,
                    style: {fontFamily: "'Courier New', Courier, monospace", letterSpacing: "0.05em",fontSize: "15px"},
                    getPreview: (values, t) => {
                        if(!values) return <></>
                        return (
                            <ul>
                                {
                                    values?.map(valueObject => {
                                        let preview = ""

                                        if (valueObject.value === "**") {
                                            preview = "Correspond à toutes les valeurs"
                                        }
                                        else if (valueObject.value .startsWith("*") && valueObject.value .endsWith("*")) {
                                            preview = `Correspond à tout ce qui contient : ${valueObject.value .slice(1, -1)}`
                                        } else if (valueObject.value .startsWith("*")) {
                                            preview = `Correspond à tout ce qui se termine avec : ${valueObject.value .slice(1)}`
                                        } else if (valueObject.value .endsWith("*")) {
                                            preview = `Correspond à tout ce qui commence par : ${valueObject.value .slice(0, -1)}`
                                        } else if (!valueObject.value .includes("*") && valueObject.value .trim() !== "") {
                                            preview = `Correspond à tout ce qui est égal à : ${valueObject.value }`
                                        }

                                        return <li>{t(preview)}</li>
                                    })
                                }
                            </ul>
                        )
                    }
                },

                {path: "contactAssociationReferent", tKey: "Référent association", section: "Contact",type: "dropdownObject", target: 'isOrganizationReferent', useInQuery: false, sortList: false},
                {path: "contactLiberalityReferent", tKey: "Référent libéralités", section: "Contact", type: "dropdownObject", target: 'isLiberalityReferent', useInQuery: false, sortList: false},
                {path: "contactFunction", tKey: "Métier", placeholder: "Sélectionner les métiers", section: "Contact", type: "tags", target: 'functions', translateName: true, useInQuery: true},
                {path: "contactProfile", tKey: "Profils", placeholder: "Sélectionner les profils", section: "Contact", type: "tags", filters: ['thisModel'], target: 'authorizations', translateName: true, useInQuery: true},

                //Shelter
                {
                    path: "shelterZipCode",
                    section: "Refuge relais",
                    tKey: 'Code postal',
                    placeholder: "Renseigner préfixe(s) code(s) postal(aux)",
                    type: "creatableTags",
                    target: "sheltersZipCodes",
                    useInQuery: false,
                    style: {fontFamily: "'Courier New', Courier, monospace", letterSpacing: "0.05em",fontSize: "15px"},
                    getPreview: (values, t) => {
                        if(!values) return <></>
                        return (
                            <ul>
                                {
                                    values?.map(valueObject => {
                                        let preview = ""

                                        if (valueObject.value === "**") {
                                            preview = "Correspond à toutes les valeurs"
                                        }
                                        else if (valueObject.value .startsWith("*") && valueObject.value .endsWith("*")) {
                                            preview = `Correspond à tout ce qui contient : ${valueObject.value .slice(1, -1)}`
                                        } else if (valueObject.value .startsWith("*")) {
                                            preview = `Correspond à tout ce qui se termine avec : ${valueObject.value .slice(1)}`
                                        } else if (valueObject.value .endsWith("*")) {
                                            preview = `Correspond à tout ce qui commence par : ${valueObject.value .slice(0, -1)}`
                                        } else if (!valueObject.value .includes("*") && valueObject.value .trim() !== "") {
                                            preview = `Correspond à tout ce qui est égal à : ${valueObject.value }`
                                        }

                                        return <li>{t(preview)}</li>
                                    })
                                }
                            </ul>
                        )
                    }
                },
                //{path: "zones", tKey: "Organisation: Région administrative", target: 'organizationZone', type: "tags", translateName: true, useInQuery: false}
            ]
            return {
                entityFields : [
                    ...defaultEntityFields,
                    ...customEntityFields,
                    getUsersGetter(customModuleFormFields),
                    usersNumberGetter(customModuleFormFields)
                ],
                moduleListFields: [
                    ...defaultModuleListFields,
                    ...customModuleListFields
                ],
                moduleFormFields: [
                    ...defaultModuleFormFields,
                    ...customModuleFormFields,
                    {path: 'numberOfUsers', editable: false}
                ]
            }
        default:
            return {
                entityFields : defaultEntityFields,
                moduleListFields: defaultModuleListFields,
                moduleFormFields: defaultModuleFormFields
            }
    }
}
export const jobs = () => []
export const entities = modelId => [
    {
        name: "EmailLanguage",
        type: "static",
        facets: ["translatedField"],
        fields: [
            {path: "id", type: "string"},
            {path: "name", type: "string"},
        ],
        filters: [
            {
                name: 'ByClient',
                isDefault: true,
                match: function (object) {
                    return global.config.languages.includes(object.id)
                }
            }
        ],
        objects: [
            {id: "en", name: 'english'},
            {id: "es", name: 'español'},
            {id: "fr", name: 'français'},
            {id: "it", name: "italiano"},
            {id: "nl", name: "nederlands"}
        ]
    },
    {
        name: "MaritalStatus",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {path: "name", type: "string"},
        ],
        objects: [
            {id: "withoutSpouse", name: "withoutSpouse"},
            {id: "withSpouse", name: "withSpouse"}
        ]
    },
    {
        name: "ReferentStatus",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {path: "name", type: "string"},
        ],
        objects: [
            {id: "yes", name: "Oui"},
            {id: "no", name: "Non"}
        ]
    },
    {
        name: "ContributionsStatus",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {path: "name", type: "string"},
            {
                path: "dynamicName",
                fieldPath: ["name"],
                $f: async function(object, context, callback) {
                    const tc = context.tc || (t => t)
                    const ongoingExercise = await global.app.C?.Exercise.collection.findOne({exerciseStatus: "ongoing"})
                    if(ongoingExercise) return callback(null, tc(object.name, {exerciseCode: ongoingExercise.code}))
                }
            },
        ],
        objects: [
            {id: "upToDate", name: "upToDateWithContributions"},
            {id: "notUpToDate", name: "notUpToDateWithContributions"}
        ]
    },
    {
        name: "BroadcastListPlatform",
        fields: fieldsByModel(modelId).entityFields,
        filters: [
            {
                name: "byIds",
                isDefault: false,
                query: function(context) {
                    const Ids = _.get(context.data, 'broadcastListsIds', []);
                    if (!Ids.length) return {_id: null}
                    return {_id: {$in: Ids.map(id => new global.ObjectID(id))}}
                }
            }
        ]
    },
    {
        name: "ReleaseDateStatus",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {path: "name", type: "string"}
        ],
        objects: [
            {id: "filled", name: "releaseDateFilled"},
            {id: "notFilled", name: "releaseDateNotFilled"}
        ]
    },
    {
        name: "EmailState",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {path: "name", type: "string"}
        ],
        objects: [
            {id: "active", name: "active"},
            {id: "archived", name: "archived"}
        ]
    },
    {
        name: "EmailMessage",
        facets: [{name: "files"}],
        fields: [
            {path: "language", type: "EmailLanguage"},
            {path: "emailSubject"},
            {path: "message"},
        ]
    },
    {
        name: "Recipients",
        type: "mongoInternal",
        fields: [
            {path: "mails"},
            {path: "language", type: "EmailLanguage"},
        ]
    },
    {
        name: "MessagingPlatform",
        fields: [
            {path: "title", unique: true},
            "description",
            {path: "broadcastLists", type: "BroadcastListPlatform", link: "MTM", nullable: true},
            {path: 'createdBy', type: 'User', nullable: true},
            {path: 'sentBy', type: 'User', nullable: true},
            {path: "recipients", type: "User", link: "MTM", nullable: true},
            {path: "testRecipients", type: "User", link: "MTM", nullable: true},
            {path: "otherRecipients", type: "Recipients", link: "OTM"},
            {path: "archived", type: "boolean", nullable: true},
            {path: "delayedSending", type: "boolean", nullable: true},
            {path: "date"},
            {path: 'shareWith', type: 'User', link: 'MTM', nullable: true},
            {path: 'status'},
            {
                path: 'finalStatus',
                fieldPath: ['status'],
                $f: function (message, context, callback) {
                    if(['draft', 'sent'].includes(message.status)) return callback(null, message.status)
                    if(message.status === 'programed') {
                        return global.app[context.model.id].EmailsQueue.collection
                            .find({"messageId": {$in: message.mails}, status: {$in: ['sending', 'sent']}})
                            .toArray()
                            .then(emails => callback(null, !!emails.length ? 'sent' : 'programed'))
                            .catch(e => callback(e))
                    }
                    return callback(null, 'notFound')

                }

            },
            {path: "mails", list: true},
            {
                path: "mailEvents",
                fieldPath: ["mails", "status"],
                $f: async function (message, context, callback) {
                    if(_.get(context, "data.state.id") !== "active") return callback(null, {})
                    try {
                        const events = await global.db.collection("mailEvent").find({
                            "message-id": {$in: _.compact(message.mails).map(messageId => `<${messageId}>`)}
                        }).toArray()

                        const bucketByEvent = {
                            request: "sent",
                            delivered: "delivered",
                            unique_opened: "opened",
                            unique_proxy_open: "opened",
                            click: "clicked",
                            hard_bounce: "blocked",
                            blocked: "blocked",
                        }

                        const sets = {
                            sent: new Set(),
                            delivered: new Set(),
                            opened: new Set(),
                            clicked: new Set(),
                            blocked: new Set(),
                        }

                        for (const ev of events) {
                            const label = bucketByEvent[ev.event]
                            if (!label) continue

                            const id = ev?.["message-id"]
                            if (!id) continue

                            sets[label].add(id)
                        }

                        return callback(null, {
                            sent: sets.sent.size,
                            delivered: sets.delivered.size,
                            opened: sets.opened.size,
                            clicked: sets.clicked.size,
                            blocked: sets.blocked.size,
                        })
                    } catch (e) {
                        return callback(e)
                    }
                },
            },
            {
                path: "mailsFollowup",
                fieldPath: ['mails', 'recipients.mail', 'recipients.name', 'finalStatus'],
                $f: function (message, context, callback) {
                    if(message.finalStatus !== 'sent') return callback(null, [])

                    global.db.collection("mailEvent").aggregate([
                        {
                            $match: {"message-id": {$in: _.compact(message.mails).map(messageId => `<${messageId}>`)}}
                        },
                        {
                            $group: {
                                _id: "$message-id",
                                messageId: {$first: "$message-id"},
                                email: {$first: "$email"},
                                events: {$push: {event: "$event", date: "$event_date"}},
                            }
                        }
                    ])
                        .toArray()
                        .then(results => callback(null, results.map(result => {
                            const recipient = message.recipients.find(recipient => decrypt(recipient.mail) === result.email)
                            const sendEvent = result.events.find(object => object.event === 'request')
                            const deliveredEvent = result.events.find(object => object.event === 'delivered')
                            const opened = result.events.find(object => object.event === 'unique_opened')
                            const proxyOpen = result.events.find(object => object.event === 'unique_proxy_open')
                            const clickedEvent = result.events.find(object => object.event === 'click')
                            const blockedEvent = result.events.find(object => object.event === 'blocked')
                            const hardBounceEvent = result.events.find(object => object.event === 'hard_bounce')

                            return ({
                                id: result.messageId,
                                recipients: recipient ? recipient.name : result.email,
                                sent: sendEvent && moment(sendEvent.date).format('YYYY-MM-DD HH:mm:ss'),
                                delivered: deliveredEvent && moment(deliveredEvent.date).format('YYYY-MM-DD HH:mm:ss'),
                                opened: opened
                                    ? moment(opened.date).format('YYYY-MM-DD HH:mm:ss')
                                    : proxyOpen
                                        ? moment(proxyOpen.date).format('YYYY-MM-DD HH:mm:ss')
                                        :'',
                                clicked: clickedEvent && moment(clickedEvent.date).format('YYYY-MM-DD HH:mm:ss'),
                                blocked: !!blockedEvent || !!hardBounceEvent ,
                            })
                        })))
                        .catch(callback)
                }
            },
            {path: "numberOfRecipients", fieldPath: ["otherRecipients"], type: 'integer', $f: (object, context, callback) => {
                    callback(
                        null,
                        _.concat(
                            object.recipients,
                            object.otherRecipients ?
                                _.flatMap(object.otherRecipients, line => line.mails.split(';'))
                                : []
                        ).length
                    )
                }},
            {path: 'messages', type: 'EmailMessage', link: 'OTM'},
            {path: 'sendDate'},
            {
                path: "noDeleteButtonAccess",
                fieldPath: ['createdBy.id', 'shareWith.id'],
                $f: function (message, context, callback) {
                    const isMessageCreator = _.get(message, 'createdBy.id') === _.get(context, 'user.id')
                    const isSharedWith = message.shareWith?.map(user => user.id).includes(_.get(context, 'user.id'))
                    callback(null, !isMessageCreator && !isSharedWith)
                }
            },
            {
                path: "sender",
                fieldPath: ['sentBy.mail'],
                $f: function (message, context, callback) {
                    const senderMail = _.get(message, 'sentBy.mail')
                    callback(null, senderMail && decrypt(senderMail))
                }
            }
        ],
        correctEmailFormat: function(object, oldObject, context, callback) {
            let wrongEmail
            const otherRecipients = _.flatMap(object.otherRecipients, line => line.mails.split(';'))

            const duplicates = otherRecipients.some(
                recipient => {
                    const isValid = validateEmail(recipient)
                    if(!isValid) {
                        wrongEmail = recipient
                    }
                    return !isValid
                }
            )

            if(duplicates) return callback(new Errors.ValidationError(context.tc('incorrectEmailFormat', {mail: wrongEmail})))
            return callback()
        },
        uniqueRecipients: function(object, oldObject, context, callback) {
            let duplicateMail
            const recipients = object.recipients.map(user => ({mail: user.mail && decrypt(user.mail)}))
            const otherRecipients = _.flatMap(object.otherRecipients, line => line.mails.split(';').map(mail => ({mail, language: line.language.id})))
            const duplicates = otherRecipients.some(
                otherRecipient => recipients.some(
                    recipient => {
                        const isDuplicate = recipient.mail === otherRecipient.mail
                        if(isDuplicate) {
                            duplicateMail = recipient.mail
                        }
                        return isDuplicate
                    }
                )
            )
            if(duplicates) return callback(new Errors.ValidationError(context.tc('duplicateUser', {mail: duplicateMail})))
            return callback()
        },
        uniqueOtherRecipients: function(object, oldObject, context, callback) {
            let duplicateMail
            const otherRecipients = _.flatMap(object.otherRecipients, line => line.mails.split(';'))

            const duplicates = otherRecipients.some(
                (recipient, index) => {
                    const isDuplicate = otherRecipients.indexOf(recipient) !== index
                    if(isDuplicate) {
                        duplicateMail = recipient
                    }
                    return isDuplicate
                }
            )

            if(duplicates) return callback(new Errors.ValidationError(context.tc('duplicateOtherRecipient', {mail: duplicateMail})))
            return callback()
        },
        uniqueMessageByLanguage: function(object, oldObject, context, callback) {
            let duplicateLanguage

            const messagesLanguages = object.messages.map(message => _.get(message, 'language.name'))

            const duplicates = messagesLanguages.some(
                (language, index) => {
                    const isDuplicate = messagesLanguages.indexOf(language) !== index
                    if(isDuplicate) {
                        duplicateLanguage = language
                    }
                    return isDuplicate
                }
            )

            if(duplicates) return callback(new Errors.ValidationError(context.tc('duplicateMessageLanguage', {language: duplicateLanguage})))
            return callback()
        },
        requiredEmailLanguages: function(object, oldObject, context, callback) {
            let missingLanguage

            const isValidated = ["validate", "send"].includes(context.action)
            const isTest = context.action === "sendTest"
            if(!isValidated && !isTest) return callback()

            const recipients = isTest
                ? object.testRecipients
                : object.otherRecipients
                    ? _.concat(
                        object.recipients,
                        _.flatMap(object.otherRecipients, line => line.mails.split(';').map(mail => ({mail, language: line.language})))
                    )
                    : object.recipients

            const isMissingLanguage = recipients.some(
                recipient => {
                    const isLanguagePresent = object.messages.some(message => message.language.id === recipient.language.id)
                    if(!isLanguagePresent) {
                        missingLanguage = recipient.language.name
                    }
                    return !isLanguagePresent
                }
            )
            if(isMissingLanguage) {
                return callback(new Errors.ValidationError(context.tc(
                    isTest  ? 'emailIsMissingTestLanguage' : 'emailIsMissingLanguage',
                    {language: missingLanguage}
                )))
            }
            return callback()
        },
        requiredRecipients: function(object, oldObject, context, callback) {
            if(["validate", "send"].includes(context.action) && !object.recipients?.length && !object.otherRecipients?.length) return callback(new Errors.ValidationError(context.tc('noRecipientsFound')))
            return callback()
        },
        testRecipientsEmpty: function(object, oldObject, context, callback) {
            if(context.action === "sendTest" && !object.testRecipients?.length) return callback(new Errors.ValidationError(context.tc('testRecipientsEmpty')))
            return callback()
        },
        validationDateValidation: function(object, oldObject, context, callback) {

            if(context.action !== "validate") return callback()

            if(!object.date) {
                return callback(new Errors.ValidationError(context.tc('missingEmailSchedulingDate')))
            }
            const compareDate = moment().add(1, "minutes").format('YYYY-MM-DD HH:mm:ss')
            if(object.date < compareDate) {
                return callback(new Errors.ValidationError(context.tc('invalidScheduledTime')))
            }
            return callback()
        },
        validateSave: function(object, oldObject, context, callback) {
            async.series([
                callback => this.correctEmailFormat(object, oldObject, context, callback),
                callback => this.testRecipientsEmpty(object, oldObject, context, callback),
                callback => this.uniqueRecipients(object, oldObject, context, callback),
                callback => this.uniqueOtherRecipients(object, oldObject, context, callback),
                callback => this.requiredEmailLanguages(object, oldObject, context, callback),
                callback => this.requiredRecipients(object, oldObject, context, callback),
                callback => this.uniqueMessageByLanguage(object, oldObject, context, callback),
                callback => this.validationDateValidation(object, oldObject, context, callback)
            ], callback)
        },
        beforeSave: async (object, oldObject, context, callback) => {
            const crudType  = context.restAction && context.restAction.crudType
            const action = context.action
            if(crudType === 'C') {
                object.createdBy = {
                    id: _.get(context, 'user.id'),
                    name: _.get(context, 'user.name'),
                    mail: encrypt(_.get(context, 'user.mail'))
                }
                object.status = 'draft'
                object.archived = false
            }
            object.sentBy = {
                id: _.get(context, 'user.id'),
                name: _.get(context, 'user.name'),
                mail: encrypt(_.get(context, 'user.mail'))
            }
            if(action === "toArchive") {
                object.archived = true
                return callback(null, object, oldObject)
            }

            if (action === "duplicate") {
                return handleDuplicateAction(object, context, e => callback(e, object, oldObject))
            }

            if(object.status === 'draft' && ["sendTest", "validate", "send"].includes(action)) {
                if(action === 'send') {
                    object.date = moment().add(2, 'minutes').format('YYYY-MM-DD HH:mm:ss')
                }
                return registerMailsInQueue(object, context, (e, messageIds) => {
                    if(!e && ["validate", "send"].includes(action)) {
                        object.status = action === 'sendTest' ? "sent" : "programed"
                        object.sendDate = moment().format('YYYY-MM-DD HH:mm:ss')
                        object.mails = messageIds
                    }
                    callback(e, object, oldObject)
                })
            }

            if(object.status === "programed" && context.action === "cancel") {
                const compareDate = moment().add(1, "minutes").format("YYYY-MM-DD HH:mm:ss")

                if(object.date <= compareDate) {
                    return callback(new Errors.ValidationError("emailCancellationError"))
                }

                return cancelMailsRegistrationInQueue(object, context, e => {
                    if(!e) {
                        object.status = "draft"
                        object.mails = []
                        object.delayedSending = false
                        object.date = ""
                    }
                    callback(e, object, oldObject)
                })
            }

            return callback(null, object, oldObject)
        }
    }
]

function registerMailsInQueue(object, context, callback) {
    const action = context.action
    const mails = prepareEmails(object, context);
    const messageIds = []
    return global.app[context.model.id].EmailsQueue.collection.insertMany(
        mails.map(mail => {
            const messageId = uuid()
            messageIds.push(messageId)
            return {
                ..._.pick(mail, ["from", "to", "replyTo", "subject", "content", "signature", "signatureFiles", "attachments"]),
                contentType: "html",
                messageId,
                delayedSending:  action !== 'sendTest',
                date: object.date,
                group: new global.ObjectID(context.group.id),
                creationDate: new Date(),
                status: "waiting"
            }
        })).then(() => callback(null, messageIds)).catch(callback)
}

function cancelMailsRegistrationInQueue(object, context, callback) {
    global.app[context.model.id].EmailsQueue.collection.deleteMany(
        {"messageId": {$in: object.mails}}
    ).then(() => callback()).catch(callback)
}

function prepareEmails(object, context) {
    const defaultMail = prepareDefaultMail(object, context)
    const recipients = context.action === "sendTest"
        ? getTestRecipients(object)
        : getUniqueRecipients(object)

    const groupModelUrl = global.isProd
        ? `https://${context.host}/business/${context.groupModel.id}`
        : `http://localhost:3000/business/${context.groupModel.id}`

    return recipients.map(user => {
        const messageElements = getMessageElements(object, user);

        return _.defaults({
            to: user.mail,
            content: `<div class="kp-container">${messageElements.message}<br/><div style="font-size: 11px"><a href="${groupModelUrl}/communication/m-${context.model.id}-userSubscription">${context.tl('unsubscribe', user.language?.id)}</a></div></div>`,
            subject: messageElements.emailSubject,
            attachments: messageElements.files.map(file => _.pick(file, ['id', 'filename']))
        }, defaultMail)
    })
}

function prepareDefaultMail(object, context) {
    const userName = _.get(object, 'sentBy.name')
    const userMail = _.get(object, 'sentBy.mail')

    const replyTo = context.group.useNoReply
        ? context.group.noReply
        : decrypt(userMail)

    const alias = context.group.useNoReply
        ? context.group.alias
        : userName

    return {
        from: `"${alias}"${replyTo}`,
        replyTo: replyTo,
        signature: false,
        signatureFiles: context.user.signature.map(signature => _.pick(signature, ["id", "date", "filename", "password"])),
        verbose: {
            general: true,
        }
    }
}

function getTestRecipients(object) {
    return object.testRecipients.map(user => ({ mail: user.mail && decrypt(user.mail), language: user.language }))
}

function getUniqueRecipients(object) {
    return object.otherRecipients
        ? _.concat(
            object.recipients.filter(user => !user.unsubscribed).map(user => ({ mail: user.mail && decrypt(user.mail), language: user.language })),
            _.flatMap(object.otherRecipients, line => line.mails.split(';').map(mail => ({ mail, language: line.language.id })))
        )
        : object.recipients.map(user => ({ mail: user.mail && decrypt(user.mail), language: user.language }))
}

function getMessageElements(object, user) {
    let messageElements = object.messages.find(message => message.language.id === (user.language?.id));
    if (!messageElements) messageElements = object.messages.find(message => message.language.id === 'fr');
    if (!messageElements) messageElements = object.messages[0];

    return messageElements;
}

function handleDuplicateAction(object, context, callback) {
    const messageCopy = createDuplicateMessage(object, context);

    global.app[context.model.id].MessagingPlatform.collection.insertOne(messageCopy).then(result => {
        const messages = prepareMessagesForDuplicate(object, result, context);
        global.app[context.model.id].EmailMessage.collection.insertMany(messages).then(() => callback()).catch(callback)
    })
}

function createDuplicateMessage(object, context) {
    return {
        title: object.title + ' copie',
        description: object.description,
        createdBy: new global.ObjectID(context.user.id),
        recipients: object.recipients.map(recipient => new global.ObjectID(recipient.id)),
        otherRecipients: object.otherRecipients.map(recipients => ({
            mails: recipients.mails,
            language: _.get(recipients, 'language.id')
        })),
        status: 'draft',
        archived: false,
        group: new global.ObjectID(context.group.id)
    };
}

function prepareMessagesForDuplicate(object, result, context) {
    return object.messages.map(message => ({
        language: _.get(message, 'language.id'),
        emailSubject: message.emailSubject,
        message: message.message,
        files: message.files.map(file => ({
            _id: new global.ObjectID(file.id),
            ..._.pick(file, ['filename', 'date', 'user']),
            group: new global.ObjectID(context.group.id)
        })),
        messagingPlatform: result.insertedId,
        group: new global.ObjectID(context.group.id)
    }));
}

export const modules = modelId => [
    {
        tKey: "m-T-BroadcastLists",
        object: "BroadcastListPlatform",
        category: {
            path: 'menuTitle_communication',
            icon: 'speech'
        },
        objectIdentifier: 'name',
        defaultSortBy: "name",
        defaultSortDirection: "ASC",
        formSections: modelId === 'C' ? [
            {id: "Organisation", tKey: "Organisation", defaultCollapsed: true},
            {id: "Etablissement", tKey: "Etablissement", defaultCollapsed: true},
            {id: "Contact", tKey: "Contact", defaultCollapsed: true},
            {id: "Refuge relais", tKey: "Refuge relais", defaultCollapsed: true},
        ] : undefined,
        viewMap: {
            dt: fieldsByModel(modelId).moduleListFields,
            form: fieldsByModel(modelId).moduleFormFields
        }
    },
    {
        tKey: "m-T-Messaging",
        object: "MessagingPlatform",
        defaultSortBy: 'sendDate',
        objectIdentifier: 'title',
        defaultSortDirection: 'DESC',
        category: {
            path: 'menuTitle_communication',
            icon: 'speech'
        },
        actions: [
            {method: 'PUT', name: 'toArchive', tKey: 'toArchive', accessIdPath: 'accessId'},
            {method: 'DELETE', name: 'delete', tKey: 'delete', accessIdPath: 'deleteAccessId'},
        ],
        viewMap: {
            dt: [
                "title",
                //{path: 'status', translate: true, width: 70},
                {path: 'finalStatus', tKey: 'status', translate: true, width: 70},
                {path: 'sender'},
                {path: 'numberOfRecipients', tKey: 'recipients', width: 120},
                {path: "date", tKey: "scheduledSendingFor", width: 150},
                {path: 'sendDate', tKey: "dateAndTime", width: 150},
                {path: 'mailEvents', width: 80, dynamic: true, disableColumnsSort: true},
                {path: "noDeleteButtonAccess", hidden: true}
            ],
            form: {
                fields: [
                    {path: 'finalStatus', tKey: 'status', translate: true, disabled: true},
                    {path: "title", required: true},
                    {path: "description", type: "textarea"},
                    {path: 'sender', disabled: true},
                    {
                        path: "broadcastLists",
                        fieldPath: ['id', 'name'],
                        subscriptions: {
                            onChange: (newValue, oldValue, { module, store, formInitialize, getObjectSuccessAction }) => {
                                if(!formInitialize && !getObjectSuccessAction) {
                                    const statusField = module.viewMap.form.fields.find(
                                        field => field.path === 'status'
                                    )

                                    if(statusField.getValue() === 'sent') return

                                    const state = store.getState()
                                    const recipientsField = module.viewMap.form.fields.find(
                                        field => field.path === 'recipients'
                                    )

                                    const list = state.dataLists.byId[`m-${module.model}-messagingPlatform.MessagingPlatform_recipients`].list

                                    if (newValue && !!newValue.length) {
                                        store.dispatch(
                                            generateFetchFieldListAction(
                                                `m-${module.model}-messagingPlatform.MessagingPlatform_filteredBroadcastLists`,
                                                store.getState,
                                                { data: { broadcastListsIds : (newValue || []).map(list => list.id) } },
                                            )
                                        ).then((response) => {
                                            const filteredBroadcastLists = response.data || []
                                            recipientsField.setValue(
                                                filteredBroadcastLists && !!filteredBroadcastLists.length
                                                    ? list.allIds
                                                        .filter(id => {
                                                            const kpUser = list.byId[id]
                                                            return filteredBroadcastLists.some(broadcastList => broadcastList.users.some(user => {
                                                                return kpUser.id === user.kpUser.toString()
                                                            }))
                                                        })
                                                        .map(id => list.byId[id])
                                                    : []
                                            )
                                        })
                                    }
                                    else {
                                        recipientsField.setValue([])
                                    }
                                }
                            }
                        }
                    },
                    {
                        path: "recipients",
                        tKey: "recipient(s)",
                        type: 'dualBoxList',
                        leftBoxTKey: 'user(s)',
                        display: 'completeInfo',
                        fieldPath: ['id', 'language.id', 'mail', 'name', 'groupModelProfiles', 'completeInfo', 'unsubscribed'],
                        filters: ['isActive', 'isInGroupModel', 'userKNotAllowed', 'notUnsubscribed']
                    },
                    {
                        path: "otherRecipients",
                        tKey: "otherRecipient(s)",
                        defaultSortBy: "language",
                        defaultSortDirection: "ASC",
                        removable: true,
                        viewMap: {
                            dt: [
                                {path: 'language', translate: true},
                                {path: 'mails', tKey: 'mail(s)'},
                            ],
                            form: [
                                {path: 'language', fieldPath: ['id', 'name'], required: true, default: {id: 'fr', name: 'french'}},
                                {path: 'mails', tKey: 'mail(s)', type: 'creatableTags', placeholder: 'typeEmailAddressAndPressEnter', required: true},
                            ]
                        }
                    },
                    {
                        path: "testRecipients",
                        tKey: "testRecipient(s)",
                        display: 'completeInfo',
                        fieldPath: ['id', 'language.id', 'mail', 'name', 'groupModelProfiles', 'completeInfo', 'unsubscribed'],
                        filters: ['isActive', 'isInGroupModel', 'userKNotAllowed', 'notUnsubscribed']
                    },
                    {
                        path: "messages",
                        removable: true,
                        required: true,
                        defaultSortBy: 'language',
                        defaultSortDirection: 'ASC',
                        viewMap: {
                            dt: [
                                {path: 'language', translate: true},
                                "emailSubject"
                            ],
                            form: [
                                {path: "language", display: 'name', required: true, default: {id: 'fr', name: 'french'}},
                                {path: "emailSubject", required: true},
                                {path: "message", type: 'richTextEditor', required: true},
                                {path: "files"}
                            ]
                        }
                    },
                    {
                        path: "mailsFollowup",
                        type: 'accordion',
                        disabled: true,
                        viewMap: {
                            dt: [
                                {path: 'recipients'},
                                {path: 'sent'},
                                {path: 'delivered'},
                                {path: 'opened'},
                                {path: 'clicked'},
                                {path: 'blocked', type: 'failureIndicator'}
                            ]
                        }
                    },
                    {path: "shareWith", tKey: "share"},
                    {
                        path: "delayedSending",
                        subscriptions: {
                            onChange: (newValue, oldValue, { store, module }) => {
                                const state = store.getState()
                                const objectMode = getObjectMode(state)


                                const statusField = module.viewMap.form.fields.find(
                                    field => field.path === 'status'
                                )
                                const isNewObject = objectMode === 'newObject'
                                const isDraft = statusField.getValue() === 'draft'
                                store.dispatch(setFieldVisibility("e_date", !!newValue))
                                if(isDraft || isNewObject) {
                                    store.dispatch(setFormButtons(
                                        !!newValue
                                            ? [
                                                {type: "action", tKey: 'validate', bsStyle: 'primary', action: 'validate'},
                                                {type: "action", tKey: 'saveAndSendTest', bsStyle: 'warning', action: 'sendTest'},
                                                {type: "save", tKey: 'saveDraft', bsStyle: 'success'},
                                                {type: "return", tKey: 'return', bsStyle: 'default'}
                                            ]
                                            : [
                                                {type: "action", tKey: 'send', bsStyle: 'primary', action: 'send', getUserConfirmation: true, confirmationMessage: 'sendingEmailsConfirmationMessage'},
                                                {type: "action", tKey: 'saveAndSendTest', bsStyle: 'warning', action: 'sendTest'},
                                                {type: "save", tKey: 'saveDraft', bsStyle: 'success'},
                                                {type: "return", tKey: 'return', bsStyle: 'default'}
                                            ]
                                    ))
                                }
                            }
                        }
                    },
                    {path: "date", tKey: "dateAndTime", type: "datePicker", showTime: true},
                    {path: "archived", hidden: true},
                    {path: "status", hidden: true},
                    {path: "mails", hidden: true},
                    {path: "createdBy", hidden: true},
                    {path: "sentBy", hidden: true},
                ],
                onOpen: ({ store }) => {
                    const state = store.getState()
                    const objectMode = getObjectMode(state)
                    const isNewObject = objectMode === 'newObject'

                    const user = getUser(state)
                    const isOwner = _.get(state, 'edit.object.data.createdBy.id') === user.id
                    const isSharedWith = state.edit.object.data.shareWith?.map(user => user.id).includes(user.id)
                    const userHasRights = isOwner || isSharedWith

                    const delayedSending = _.get(state, 'edit.object.data.delayedSending')
                    const date = _.get(state, 'edit.object.data.date')
                    const isArchived = _.get(state, 'edit.object.data.archived')

                    const asyncStatus = _.get(state, 'edit.object.data.finalStatus')
                    const isDraft = asyncStatus === 'draft'
                    const isSent = asyncStatus === 'sent'
                    const isProgramed = asyncStatus === 'programed'

                    const compareDate = moment().add(1, "minutes").format("YYYY-MM-DD HH:mm:ss")

                    const cannotUpdateProgram = date <= compareDate

                    const objectIsEditable =  isNewObject || (userHasRights && !isSent && !isProgramed)

                    if(objectMode === 'newObject') {
                        store.dispatch(setFieldVisibility(`e_date`, false))
                    }

                    //visible only when editObject
                    store.dispatch(setFieldVisibility(`e_finalStatus`, !isNewObject))

                    // visible only when mail is sent not editable
                    const group1 = ['sender', 'mailsFollowup']
                    group1.forEach(
                        path => store.dispatch(setFieldVisibility(`e_${path}`, isSent))
                    )


                    // visible id mail not sent
                    const group2 = ['broadcastLists', 'recipients', 'otherRecipients', 'testRecipients']
                    group2.forEach(
                        path => store.dispatch(setFieldVisibility(`e_${path}`, !isSent))
                    )

                    // editable if not sent nor programed and id user had rights
                    const group4 = ['title', 'description', 'broadcastLists', 'recipients', 'otherRecipients', 'testRecipients', 'shareWith', 'messages', 'delayedSending', 'date']
                    group4.forEach(
                        path => store.dispatch(setFieldEdition(`e_${path}`, objectIsEditable))
                    )

                    // only newable and removable when updatable
                    const group5 = ['otherRecipients', 'messages']
                    group5.forEach(
                        path => {
                            store.dispatch(setFieldNewable(`e_${path}`, objectIsEditable))
                            store.dispatch(setFieldRemovable(`e_${path}`, objectIsEditable))
                        }
                    )

                    const draftActions = [
                        {type: "action", tKey: 'saveAndSendTest', bsStyle: 'warning', action: 'sendTest'},
                        {type: "save", tKey: 'saveDraft', bsStyle: 'success'},
                        {type: "return", tKey: 'return', bsStyle: 'default'}
                    ]


                    const sentActions = isArchived
                        ? [
                            {type: "action", tKey: "duplicate", bsStyle: 'primary', action: "duplicate"},
                            {type: "return", tKey: 'return', bsStyle: 'default'},
                        ]
                        : [
                            {type: "action", tKey: "duplicate", bsStyle: 'primary', action: "duplicate"},
                            {type: "action", tKey: "toArchive", bsStyle: 'warning', action: "toArchive"},
                            {type: "return", tKey: 'return', bsStyle: 'default'}
                        ]



                    store.dispatch(setFormButtons(
                        isNewObject || isDraft
                            ? delayedSending
                                ? [
                                    {type: "action", tKey: 'validate', bsStyle: 'primary', action: 'validate'},
                                    ...draftActions
                                ]
                                : [
                                    {type: "action", tKey: 'send', bsStyle: 'primary', action: 'send', getUserConfirmation: true, confirmationMessage: 'sendingEmailsConfirmationMessage'},
                                    ...draftActions
                                ]
                            : cannotUpdateProgram || isSent
                                ? sentActions
                                : [
                                    {type: "action", tKey: 'cancelDelayedSending', bsStyle: 'warning', action: 'cancel'},
                                    {type: "return", tKey: 'return', bsStyle: 'default'}
                                ]

                    ))
                },
                dataLists: [`m-${modelId}-messagingPlatform.MessagingPlatform_filteredBroadcastLists`],
            }
        },
        accesses: [
            {
                id: `m-${modelId}-messagingPlatform.MessagingPlatform_filteredBroadcastLists`,
                entity: "BroadcastListPlatform",
                fieldPath: ['id', ...fieldsByModel(modelId).entityFields.map(field => field.path)],
                filters: [ 'byIds']
            },
        ],
        actionSubscriptions: [
            {
                actionType: SAVE_OBJECT_SUCCESS,
                subscription: ({ store }) => {
                    const state = store.getState()
                    const moduleId = _.get(state, 'module.id')
                    store.dispatch(fetchDtData(moduleId))
                }
            }
        ],
        filters: [
            {
                path: 'state',
                object: 'EmailState',
                client: true,
                display: "name",
                translate: true,
                default: {id: 'active'},
                query: function(context) {
                    const state = context.data && context.data.state

                    return state
                        ? { archived : state.id === "archived"}
                        : {}
                }
            }
        ]
    },
    {
        tKey: "m-T-Subscription",
        kp: true,
        object: "User",
        name: "UserSubscription",
        category: {
            path: 'menuTitle_communication',
            icon: 'speech'
        },
        objectIdentifier: 'name',
        defaultSortBy: "name",
        defaultSortDirection: "ASC",
        defaultFormButtons: [
            {
                type: 'save',
                tKey: 'validate',
                bsStyle: 'primary'
            },
            {
                type: 'return',
                tKey: 'return',
                bsStyle: 'default'
            }
        ],
        viewMap: {
            dt: {
                fields: [
                    {path: "name"},
                    {path: "unsubscribed"},
                ],
                onLoad: ({state, store}) => {
                    const userId = _.get(state, 'user.id')
                    store.dispatch(fetchFormObject(userId))
                    store.dispatch(setObjectMode('editObject'))
                }
            },
            form: [
                {path: "unsubscribed", tKey: 'Je souhaite me désabonner de toutes les communications par email'},
            ]
        },
        filters: [
            {
                title: "byUser",
                query: context => {
                    return {_id: new global.ObjectID(context.user.id)}
                }
            }
        ],
        actionSubscriptions: [
            {
                actionType: SAVE_OBJECT_SUCCESS,
                subscription: ({store}) => {
                    const state = store.getState()
                    const groupModel = getGroupModel(state)
                    const history = require('../../../history').default
                    history.push(`/business/${groupModel.id}`)
                }
            }
        ]
    }
]
